'use client';

import { useEffect, useState } from 'react';
import type { DEVICE_TYPE } from '../constants';
import { checkDeviceType, checkDeviceTypeBrowser } from '../utils';
import { useCacheKey } from './useCacheKey';

export const useDeviceType = (): DEVICE_TYPE => {
    const { headers } = useCacheKey();
    const deviceTypeFromHeader = headers.get('x-petm-device') ?? '';
    const [deviceType, setDeviceType] = useState<DEVICE_TYPE>(() => checkDeviceType(deviceTypeFromHeader));

    useEffect(() => {
        setDeviceType(checkDeviceTypeBrowser());
    }, []);

    useEffect(() => {
        const changeDeviceType = () => {
            setDeviceType(checkDeviceTypeBrowser());
        };
        window.addEventListener('resize', changeDeviceType);

        return () => {
            window.removeEventListener('resize', changeDeviceType);
        };
    }, []);

    return deviceType;
};
